import Color from '@components/Color';
import { FormControl, FormLabel } from '@mui/material';
import React from 'react';

type Props = {
	color: string;
	onChange: (hex: string) => void;
	// eslint-disable-next-line react/require-default-props
	disableAlpha?: boolean;
	// eslint-disable-next-line react/require-default-props
	label?: string;
};

const ColorControl: React.FC<Props> = ({
	color,
	onChange,
	disableAlpha,
	label
}: Props) => (
	<FormControl fullWidth margin="normal" component="fieldset">
		<FormLabel component="legend">{label}</FormLabel>
		<Color
			color={color}
			onChange={onChange}
			disableAlpha={disableAlpha}
			data-testid="color-control"
		/>
	</FormControl>
);

export { ColorControl };
